'use client';

import React, { useState } from 'react';
import LoginWithOTP from './LoginWithOTP';
import LoginWithPass from './LoginWithPass';

const LoginForm = ({ redirect }: any) => {
  const [isPassword, setIsPassword] = useState(false);

  return (
    <>
      {isPassword ? (
        <LoginWithPass redirect={redirect} />
      ) : (
        <LoginWithOTP redirect={redirect} />
      )}

      {/* --- New Login Options --- */}
      <div className="d-flex align-items-center my-4">
        <div className="flex-grow-1 border-top"></div>
        <span className="mx-3 text-muted small">OR</span>
        <div className="flex-grow-1 border-top"></div>
      </div>

      <button
        onClick={() => setIsPassword(!isPassword)}
        className="trk-btn trk-btn--primary d-block mt-3"
      >
        {isPassword ? 'Login With OTP' : 'Login With Password'}
      </button>
    </>
  );
};

export default LoginForm;
